"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
var theme_1 = require("../../components/theme");
exports.CSS = {
    container: 'c-DrawToolbar',
    column: 'c-DrawToolbar__column',
    group: 'c-DrawToolbar__group',
    insightMask: 'c-DrawToolbar__insightMask',
    insightMarker: 'c-DrawToolbar__insightMarker',
    insightButton: 'c-DrawToolbar__insightButton'
};
exports.Style = (_a = {},
    _a[exports.CSS.container] = {
        position: 'absolute',
        top: 0,
        right: 0,
        display: 'flex'
    },
    _a[exports.CSS.column] = {
        display: 'flex',
        'flex-direction': 'column'
    },
    _a[exports.CSS.group] = {
        display: 'flex',
        'flex-direction': 'column',
        'align-items': 'center',
        'flex-shrink': 0,
        'box-shadow': theme_1.DefaultTheme.shadow.box.dp2,
        overflow: 'hidden',
        'margin-top': theme_1.DefaultTheme.space(2),
        'margin-right': theme_1.DefaultTheme.space(2),
        'border-radius': '8px',
        '& > button': {
            border: 'none',
            'box-shadow': 'none',
            'border-radius': '0px',
            margin: '0px'
        },
        '& > button:not(.hidden):first-child': {
            'border-top-left-radius': '8px',
            'border-top-right-radius': '8px'
        },
        '& > button:not(.hidden):last-child': {
            'border-bottom-left-radius': '8px',
            'border-bottom-right-radius': '8px'
        }
    },
    _a[exports.CSS.insightMask] = {
        color: theme_1.DefaultTheme.font.color.insight,
        'background-color': theme_1.DefaultTheme.color.insight,
        '&:focus:not(:active)': {
            'background-color': theme_1.DefaultTheme.color.insight
        }
    },
    _a[exports.CSS.insightMarker] = {
        color: theme_1.DefaultTheme.font.color.primary,
        'background-color': theme_1.DefaultTheme.color.accent,
        '&:focus:not(:active)': {
            'background-color': theme_1.DefaultTheme.color.accent
        }
    },
    _a);
//# sourceMappingURL=draw.toolbar.style.js.map